// extracted by mini-css-extract-plugin
export default {"titleRow":"News_titleRow__DloHX","newsContainer":"News_newsContainer__qa6wH","newsContent":"News_newsContent__0yBtg","news":"News_news__ZCW80","arrowsCol":"News_arrowsCol__qHoUm"};